/**
 * PB Desktop Mega Menu — submenu accordion on click; promo swaps by menu item title.
 */
(function () {
  function getTitleKey(el) {
    return (el?.dataset?.menuItemTitle || '').trim().toLowerCase();
  }

  function getNavigableUrl(el) {
    const url = (el?.dataset?.menuItemUrl || '').trim();
    return url && url !== '#' ? url : '';
  }

  function getDefaultPromoTitle(panel) {
    return (panel.dataset.defaultPromoTitle || '').trim().toLowerCase();
  }

  function findPromoPanel(panel, titleKey) {
    const normalizedKey = (titleKey || '').trim().toLowerCase();
    if (!normalizedKey) return null;

    return (
      Array.from(panel.querySelectorAll('[data-promo-panel]')).find(
        (promo) => promo.dataset.promoPanel === normalizedKey
      ) || null
    );
  }

  function updateToggleIcons(panel, activeIndex) {
    panel.querySelectorAll('.pb-unified-mega-menu__primary-trigger--expandable').forEach((trigger) => {
      const icon = trigger.querySelector('.pb-unified-mega-menu__toggle-icon');
      if (!icon) return;

      const isActive =
        activeIndex !== null && activeIndex !== undefined && trigger.dataset.submenuIndex === String(activeIndex);
      icon.textContent = isActive ? '−' : '+';
    });
  }

  function activatePromoByTitle(panel, titleKey) {
    const promos = panel.querySelectorAll('[data-promo-panel]');
    if (!promos.length) return;

    const normalizedKey = (titleKey || '').trim().toLowerCase();
    let activeKey = normalizedKey;

    if (!findPromoPanel(panel, activeKey)) {
      const defaultKey = getDefaultPromoTitle(panel);
      if (!findPromoPanel(panel, defaultKey)) {
        return;
      }
      activeKey = defaultKey;
    }

    promos.forEach((promo) => {
      const isActive = promo.dataset.promoPanel === activeKey;
      promo.classList.toggle('is-active', isActive);
      if (isActive) {
        promo.removeAttribute('hidden');
      } else {
        promo.setAttribute('hidden', '');
      }
    });
  }

  function activateSubmenu(panel, index, titleKey) {
    const triggers = panel.querySelectorAll('.pb-unified-mega-menu__primary-trigger--expandable');
    const submenus = panel.querySelectorAll('[data-submenu-panel]');

    triggers.forEach((trigger) => {
      const isActive = trigger.dataset.submenuIndex === String(index);
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    submenus.forEach((submenu) => {
      const isActive = submenu.dataset.submenuPanel === String(index);
      submenu.classList.toggle('is-active', isActive);
      if (isActive) {
        submenu.removeAttribute('hidden');
      } else {
        submenu.setAttribute('hidden', '');
      }
    });

    updateToggleIcons(panel, index);
    activatePromoByTitle(panel, titleKey);
  }

  function closeAllSubmenus(panel) {
    panel.querySelectorAll('.pb-unified-mega-menu__primary-trigger--expandable').forEach((trigger) => {
      trigger.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
    });

    panel.querySelectorAll('[data-submenu-panel]').forEach((submenu) => {
      submenu.classList.remove('is-active');
      submenu.setAttribute('hidden', '');
    });

    updateToggleIcons(panel, null);
    activatePromoByTitle(panel, getDefaultPromoTitle(panel));
  }

  function resetPanel(panel) {
    const defaultIndex = panel.dataset.defaultSubmenuIndex;
    const defaultPromoTitle = getDefaultPromoTitle(panel);

    if (defaultIndex !== '') {
      const defaultTrigger = panel.querySelector(
        `.pb-unified-mega-menu__primary-trigger--expandable[data-submenu-index="${defaultIndex}"]`
      );
      const promoTitle = defaultPromoTitle || getTitleKey(defaultTrigger);
      activateSubmenu(panel, defaultIndex, promoTitle);
      return;
    }

    if (defaultPromoTitle) {
      activatePromoByTitle(panel, defaultPromoTitle);
    }
  }

  function initPanel(panel) {
    if (panel.dataset.pbDesktopMegaMenuInit === 'true') return;
    panel.dataset.pbDesktopMegaMenuInit = 'true';

    resetPanel(panel);

    panel.querySelectorAll('.pb-unified-mega-menu__primary-trigger--expandable').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        // Trigger can be an <a href> (SEO); navigation only happens on the second click below.
        event.preventDefault();
        const index = trigger.dataset.submenuIndex;
        const isActive = trigger.classList.contains('is-active');

        if (isActive) {
          const url = getNavigableUrl(trigger);
          if (url) {
            window.location.assign(url);
            return;
          }

          closeAllSubmenus(panel);
          return;
        }

        const promoTitle = getTitleKey(trigger);
        if (findPromoPanel(panel, promoTitle)) {
          activateSubmenu(panel, index, promoTitle);
          return;
        }

        activateSubmenu(panel, index, getDefaultPromoTitle(panel));
      });
    });

    panel.querySelectorAll('.pb-unified-mega-menu__primary-link[data-menu-item-title]').forEach((link) => {
      link.addEventListener('mouseenter', () => {
        const promoTitle = getTitleKey(link);
        if (findPromoPanel(panel, promoTitle)) {
          activatePromoByTitle(panel, promoTitle);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pb-unified-mega-menu-panel]').forEach(initPanel);
  }

  window.PBUnifiedMegaMenu = { init: initAll, resetPanel };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
